export interface QuoteStatusHistory {
  id: number;
  quoteId: number;
  previousStatus: string;
  newStatus: string;
  changedAt: string;
  changedBy: string;
}

export interface QuoteViewModel {
  id: number;
  quoteId: number;
  idNumber: string;
  firstName: string;
  lastName: string;
  cellNumber: string;
  loanPurpose: string;
  status: string;
  clientNumber: number;
  userName: string;
  branchName: string;
}

export class QuoteModel implements QuoteViewModel {
  id!: number | 0;
  quoteId: number;
  idNumber: string;
  firstName: string;
  lastName: string;
  capital: number;
  cellNumber: string;
  loanPurpose: string;
  status: string;
  userName: string;
  branchName: string;
  clientNumber: number;
  clientStatus: string;
  rejectOfferReason: string;
  rejectCompliance: string;
  rejectOtherReason: string;
  branchSerial: any;
  branchSerialNumber: any;
  myBenefitsOption: any;
  clientType: any;
  employerName: string;
  offer: any[];
  allowedProducts: any[];
  isConfirmedAddressDetails: boolean;
  isConfirmedEmploymentDetailsDetails: boolean;
  isConfirmedBankingDetails: boolean;
  isConfirmedNokDetails: boolean;
  isConfirmedDocScanningDetails: boolean;
  loanProcessingConfirmed: boolean = false;
  newLoanProcessingConfirmed: boolean = false;
  firstLoan?: boolean = false;
  firstLoanOfTheDay?: boolean = false;
  initiatedBy?: string;
  ltApprovalStatus?: 'pending' | 'approved' | 'rejected' | null;
  ltApprovalType?: 'AM' | 'RM' | null; // Add 'BM' for Branch Manager if required. Not neededd currently
  ltApprovedBy?: string;
  createdDate?: Date;
  ltApprovalDate?: Date;
  employment?: any;

  affordabilityLineItems?: any[];
  hasMultipleLoanCurrentDay?: boolean;
  ltOverrideApproval?: string;

  // checkAffordabilityFirstOfDay?(): boolean {
  //   const today = new Date();
  //   const quoteDate = this.createdDate ? new Date(this.createdDate) : null
  //   if (!this.affordabilityLineItems || !Array.isArray(this.affordabilityLineItems) || Array.from(this.affordabilityLineItems).length === 0) {
  //     return false;
  //   }

  //   this.affordabilityLineItems
  //   .filter(i => {i.type == 'INTERNAL'})
  //   .sort((a, b) => {
  //     const dateA = new Date(a.createdDate);
  //     const dateB = new Date(b.createdDate);
  //     return dateA.getTime() - dateB.getTime();
  //   });

  //   const firstAffordability = this.affordabilityLineItems[0];
  //   const firstAffordabilityDate = new Date(firstAffordability.createdDate);

  //   //this.multipleLoanRequired = this.multipleLoanRequired || (this.affordabilityLineItems.length > 0 && quoteDate ? quoteDate.toDateString() === new Date(this.affordabilityLineItems[0].createdDate).toDateString() : false);
  //   return this.multipleLoanRequired || (quoteDate && firstAffordabilityDate && quoteDate.toDateString() === firstAffordabilityDate.toDateString()) || false;
  //   //return (quoteDate && firstAffordabilityDate && quoteDate.toDateString() === firstAffordabilityDate.toDateString()) || false;
  // };
}
